import { ToggleButton, ToggleButtonGroup, FormLabel , FormControl, FormHelperText, Typography} from "@mui/material";
import { Controller } from "react-hook-form";
import './../App.css';

export default function Scale({name, control, errors, question, helper, options, required}) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={0}
            render={({ field : {onChange, value}}) => 
            <FormControl error={errors? true: false} fullWidth>
                <FormLabel required={required}>{question}</FormLabel>
                {helper? helper.map(text => (
                    <FormHelperText key={text} className="wrap-it helper">{text}</FormHelperText>
                )) : null}
                <ToggleButtonGroup 
                className='scale-group'
                color='primary'
                value={value}
                exclusive 
                onChange={(e, newValue) => onChange(newValue)}
                >   
                {options.map(option => (
                    <ToggleButton className='scale' key={option} value={option}>{option}</ToggleButton>
                ))}
                </ToggleButtonGroup>
                <Typography className="font-14 error-message">
                    {errors?.message}
                </Typography>
            </FormControl>
            }
        />
    );
}